export default __webpack_public_path__ + "static/media/cg3.3f097b92.webp";